import React, {useCallback, useEffect, useState} from 'react';
import {
  Stack,
  Typography,
  Tabs,
  Tab,
  Skeleton,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Autocomplete, Button, TextField
} from '@mui/material';
import TableRowsIcon from '@mui/icons-material/TableRows';
import GridViewIcon from '@mui/icons-material/GridView';
import api from "../../../services/api";
import Tooltip from "@mui/material/Tooltip";
import LargePopper from "../../../components/Table/assets/LargePopper";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import CircularProgress from "@mui/material/CircularProgress";

interface Filter {
  name: string;
  data: Array<{ name: string; id: string }>;
  wait?: string;
}

interface FastFiltersProps {
  handleChangeFastFilter: (value: number) => void;
  onChangeView: (value: any) => void;
}

const FastFilters: React.FC<FastFiltersProps> = ({handleChangeFastFilter,onChangeView}) => {

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(0);
  const [rows, setRows] = useState<any>([]);
  const [view, setView] = useState<any>('grid');

  const fetchVisibleActivities = useCallback(async () => {
    setLoading(true);

    await api
      .get(`/sales-partner/activity-categories`)
      .then((result: any) => {
        setRows(result);
        setLoading(false);
      })
      .catch((error) => {
      });
  }, []);

  useEffect(() => {
    fetchVisibleActivities();
  }, []);

  const handleChangeView = (value:any) => {
    onChangeView(value);
    setView(value);
  };


  return (
    <Stack
      direction={'column'}
      sx={{
        background: '#fff',
        borderRadius: '10px',
        boxShadow: '0px 0px 10px -5px #00000091',
        p: '10px',
        m: '10px',
        marginTop: '5px',
        marginBottom: '0px',
        minHeight: '48px',
      }}
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        gap={2}
      >
        <Box
        sx={{
          width: '350px'
        }}>
          <Autocomplete
            PopperComponent={LargePopper}
            freeSolo
            title={'Select Type'}
            onOpen={() => fetchVisibleActivities()}
            fullWidth={true}
            size="small"
            loading={loading}
            options={rows}
            getOptionLabel={(option:any) => option?.name}
            getOptionKey={(option:any) => option?.id}
            onChange={(event, newValue) => {
              handleChangeFastFilter(newValue?.id);
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Select Type"
                  size="small"
                  InputLabelProps={{
                    style: {
                      fontSize: 13,
                      paddingTop: 2,
                    },
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress
                            color="inherit"
                            size={20}
                            className={
                              'absolute right-[9px] text-[#b7b7b7] top-[1px]'
                            }
                          />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              );
            }}
          />
        </Box>
        <Stack justifyContent="flex-end" alignItems="center">
          <ToggleButtonGroup
            color="primary"
            value={view}
            exclusive
            onChange={(e, val) => val && handleChangeView(val)}
            size="small"
            aria-label="view toggle"
          >
            <ToggleButton value="table" aria-label="Table view">
              <Tooltip title="Table View" arrow>
                <TableRowsIcon />
              </Tooltip>
            </ToggleButton>
            <ToggleButton value="grid" aria-label="Grid view">
              <Tooltip title="Grid View" arrow>
                <GridViewIcon />
              </Tooltip>
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>

      </Stack>
    </Stack>
  );
};

export default FastFilters;
